var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 20.5,
    fill: "#FCF2F3",
    stroke: "url(#paint0_linear_4186_6173)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.62 19.79C17.06 22.62 19.38 24.94 22.21 26.38L24.41 24.18C24.69 23.9 25.08 23.82 25.43 23.93C26.55 24.3 27.75 24.5 29 24.5C29.2652 24.5 29.5196 24.6054 29.7071 24.7929C29.8946 24.9804 30 25.2348 30 25.5V29C30 29.2652 29.8946 29.5196 29.7071 29.7071C29.5196 29.8946 29.2652 30 29 30C24.4913 30 20.1673 28.2089 16.9792 25.0208C13.7911 21.8327 12 17.5087 12 13C12 12.7348 12.1054 12.4804 12.2929 12.2929C12.4804 12.1054 12.7348 12 13 12H16.5C16.7652 12 17.0196 12.1054 17.2071 12.2929C17.3946 12.4804 17.5 12.7348 17.5 13C17.5 14.25 17.7 15.45 18.07 16.57C18.18 16.92 18.1 17.31 17.82 17.59L15.62 19.79Z",
    fill: "#C7222A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4186_6173",
    x1: 21,
    y1: 1,
    x2: 21,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.57d6e7f1b689619c15fc8c094e9a1255.svg";
export { ForwardRef as ReactComponent };